module.exports = __webpack_public_path__ + "img/692-c13e13.png";